// MakingofaRobot
import React from 'react';
import { MariaMontessoriDay2026 } from '../views';

const LogisticsPage = () => {
  return <MariaMontessoriDay2026 />;
};

export default LogisticsPage;
